import { gql } from "@apollo/client";

export const CONNECT_APP = gql`
	mutation ConnectApp {
		connectApp(input: {}) {
			key: string
		}
	}
`;
